import dynamic from 'next/dynamic'
import { useRef } from 'react'
import { Spinner } from '../'
import { useWindowHasMounted } from '../../hooks'

const Leaflet = dynamic(() => import('./Leaflet'), { ssr: false })

const Map = () => {
  const hasMounted = useWindowHasMounted()
  const MapElement = useRef(null)

  if (!hasMounted) {
    return <Spinner />
  }

  return (
    <div
      data-testid="map_container_div"
      id="map"
      ref={MapElement}
      style={{ width: '100%', height: '100%' }}
    >
      <Leaflet />
    </div>
  )
}

export default Map
